import { render, staticRenderFns } from "./ProviderList.vue?vue&type=template&id=382f8651&scoped=true&"
import script from "./ProviderList.vue?vue&type=script&lang=js&"
export * from "./ProviderList.vue?vue&type=script&lang=js&"
import style0 from "./ProviderList.vue?vue&type=style&index=0&id=382f8651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382f8651",
  null
  
)

export default component.exports